<div class="flex flex-col justify-center items-center  ">
  <div class="font-bold pb-1 md:pb-6">Giảm giá</div>
  <div class="relative flex items-center justify-center">
    <div (click)="openDropdown()" [closeOnOutSide]="isDropdown" (clickedOutside)="closeDropdown()"
      class="relative flex items-center justify-center cursor-pointer">
      <fa-icon class="absolute -mt-1 text-gray-500 right-4" [icon]="faIcons.iconSortDown"></fa-icon>
      <ng-content></ng-content>
    </div>
    <div *ngIf="isDropdown" class="shadow-dropdown absolute top-8 border-gray-100 border rounded-md text-gray-500 bg-white z-50 w-full">
      <div class="py-1.5 cursor-pointer hover:bg-green-100 hover:">
        <div (click)="action.emit({type: 'addItem', group: 'discount'})" class="px-4 flex">
          <div class="pr-2">Tạo giảm giá mới</div>
          <fa-icon [icon]="faIcons.iconPlus"></fa-icon>
        </div>
      </div>
      <div *ngFor="let discount of discounts" class="flex items-center relative">
        <div
          (click)="action.emit({type: 'selectEvent', group: 'discount', index: index, bookId: book.bookId, title: book.title, priceId: null, discountId: discount.discountId, freeChapters: null, percent: discount.percent, firstMoney: book.money, endDate: discount.endDate})"
          class="cursor-pointer hover:bg-green-100 hover:flex px-4 items-center w-full py-1.5">
          <div class="pr-1">{{discount.text}}</div>
          <div *ngIf="discount.uiEndDate" class="text-red-500 text-xs">({{discount.uiEndDate | date :'dd/MM/yyyy'}})</div>
        </div>
        <div (click)="action.emit({type: 'deleteItem', id: discount.discountId, group: 'discount'})"
          class="absolute right-0 z-50 transition duration-300 ease-in-out transform hover:-translate-y-1 hover:scale-100">
          <fa-icon class="pr-2 cursor-pointer" [icon]="faIcons.iconTimesCircle"></fa-icon>
        </div>
      </div>
    </div>
  </div>
</div>